export interface ClientFaqData {
  question: string;
  answer: string;
}

export interface ClientHelpAndSupportData {
  title: string;
  description?: string;
  faqs: ClientFaqData[];
}
